import React, { useContext } from 'react'
// import style from './Soil.module.css'
import { useTranslation } from 'react-i18next'
import { LangContext } from '../context/LangContext'
import soilTest1 from '../../assets/images/اختبار دك التربة بالجهاز النووي 1.webp'
import soilTest2 from '../../assets/images/03.webp'
import soilTest3 from '../../assets/images/04.webp'
import soilTest4 from '../../assets/images/_MG_8751.webp'
import soilTest5 from '../../assets/images/_MG_8758.webp'
import soilTest6 from '../../assets/images/فني مختبر 9.webp'
import soilTest7 from '../../assets/images/اختبار لوس أنجلوس لمواد الركام.webp'
import soilTest8 from '../../assets/images/تجهيز عينة تربة للاختبار.webp'
import soilTest9 from '../../assets/images/فني مختبر 7.webp'
import soilTest10 from '../../assets/images/فني مختبر 8.webp'
import soilTest11 from '../../assets/images/اختبار التحليل المنخلي للتربة -Sieve Analysis Of Soil.webp'
import soilTest12 from '../../assets/images/اختبار نقطة التحميل لعينة صخرية مكسرة Point load test.webp'
import soilTest13 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.06.33 PM.webp'
import soilTest14 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.06.34 PM.webp'
import soilTest15 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.07.19 PM.webp'
import asphaltTest from '../../assets/images/Screenshot.webp'
import asphaltTest1 from '../../assets/images/أخذ عينة اسفلت - كور من أحد المواقع منطقة المدينة المنورة.webp'
import asphaltTest2 from '../../assets/images/أخذ كور من طبقة اسفلتية 1.webp'
import asphaltTest3 from '../../assets/images/أخذ كور من طبقة الاسفلت لأخد المواقع.webp'
import asphaltTest4 from '../../assets/images/اختبار الكثافة القصوى للاسفلت.webp'
import asphaltTest5 from '../../assets/images/اختبار قياس دمك الاسفلت بالجهاز النووي.webp'
import asphaltTest6 from '../../assets/images/اختبار مارشال على عينة اسلفت.webp'
import asphaltTest7 from '../../assets/images/استخرج عينة اسفلتية من فرن الاستخلاص بالحرق لتحديد نسبة البيتومين.webp'
import asphaltTest8 from '../../assets/images/اختبار قياس الثبات لعينة مارشال الاسفلتية.webp'
import asphaltTest9 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.08.44 PM.webp'
import asphaltTest10 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.08.45 PM.webp'
import bitumen1 from '../../assets/images/Bitumen-Sprayer-Truck-Asphalt-Distributor-with-High-Quality.webp'
import concentrate from '../../assets/images/image000501.webp'
import concentrate1 from '../../assets/images/021.webp'
import concentrate2 from '../../assets/images/022.webp'
import concentrate3 from '../../assets/images/image00009.webp'
import concentrate4 from '../../assets/images/اختبار عينات كور خرساني.webp'
import concentrate5 from '../../assets/images/اختبار SLUMP CONE.webp'
import concentrate6 from '../../assets/images/اختبار قياس مقاومة الخرسانة.webp'
import concentrate7 from '../../assets/images/اختبار قياس مقاومة الضغط للعينات الخرسانة1.webp'
import concentrate8 from '../../assets/images/اختبار مقاومة الضغط للخرسانة.webp'
import concentrate9 from '../../assets/images/تغليف عينات الكور الخرساني بالكبريت قبل اختبارها بجهاز الكسر.webp'
import concentrate10 from '../../assets/images/تجهيز قوالب عينات الخرسانة الاسطوانية بأحد المواقع.webp'
import concentrate11 from '../../assets/images/قص وتجهيز عينات اللب الخرساني.webp'
import concentrate12 from '../../assets/images/معالجة الخرسانة.webp'
import concentrate13 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.12.15 PM (1).webp'
import concentrate14 from '../../assets/images/WhatsApp Image 2025-02-11 at 9.12.15 PM.webp'
import blockTile1 from '../../assets/images/اختبار.webp'
import blockTile2 from '../../assets/images/اختبار الانحناء لعينات البلاط2.webp'
import blockTile3 from '../../assets/images/اختبار مقاومة البلوك.webp'
import penetration from '../../assets/images/bitumen-penetration-test-apparatus-500x500.webp'
import flashPoint from '../../assets/images/flash-point-tester-500x500.webp'
import flashDrawing from '../../assets/images/be9e3ea7d2183918b1e0649b3d36aaca.webp'
import softeningPoint from '../../assets/images/0023740_softening-point-ring-and-ball-apparatus_600.webp'
import volatility from '../../assets/images/Rotational-Viscometer-used-for-the-Brookfield-Viscosity-Test-Source-18.webp'
import viscosity from '../../assets/images/H95542028253843d3bf71fac534aef7e4V.jpg_720x720q50.webp'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Soil() {
  
  const { t } = useTranslation()
  let {language}= useContext(LangContext)

  const soilTestImages = [
    soilTest1, soilTest2, soilTest3, soilTest4, soilTest5, soilTest6, soilTest7, soilTest8, soilTest9, soilTest10, soilTest11, soilTest12, soilTest13, soilTest14, soilTest15,
  ]

  const asphaltTestImages = [
    asphaltTest1, asphaltTest2, asphaltTest3, asphaltTest4, asphaltTest5, asphaltTest6, asphaltTest7, asphaltTest8, asphaltTest9, asphaltTest10,
  ]
  
  const concentrateImages = [
    concentrate1, concentrate2, concentrate3, concentrate4, concentrate5, concentrate6, concentrate7, concentrate8, concentrate9, concentrate10, concentrate11, concentrate12, concentrate13, concentrate14,
  ]
  const bitumenImages = [
    { id:'1',
      name:'penetration test',
      image:penetration
    }, 
    { id:'2',
      name:'flash Point test',
      image:flashPoint
    }, 
    { id:'3',
      name:'flash Drawing test',
      image:flashDrawing
    }, 
    { id:'4',
      name:'softening Point test',
      image:softeningPoint
    }, 
    { id:'5',
      name:'volatility test',
      image:volatility
    }, 
    { id:'6',
      name:'viscosity test',
      image:viscosity
    }
  ]

  return <>
  <div dir={language==='en'? '':'rtl'} className="header-img py-5">
    <div className='w-90 mx-auto d-flex h-100 flex-column align-items-center justify-content-center'>
      <p data-aos="zoom-in" className='position-relative line fs-2 fw-bold text-black d-flex align-items-center text-center justify-content-center pb-3 mt-3 mb-5'>{t('navSoil')}</p>
    </div>
  </div> 
  <div dir={language==='en'? '':'rtl'} className='container-md w-90 mx-auto pb-4'>
    <section id='soilAggregateTest' className='w-100 pt-5'>
      <div className="row align-items-center mt-md-5">
        <div className="col-xxl-8 col-xl-7 col-lg-6">
          <ul className={`fs-4 fw-bold px-0`}>
            <li className='py-2'>
              <p data-aos="fade-up" data-aos-delay="500" className='position-relative w-fit line3 text-main2'>1. {t('navSoilAggregateTest')} :</p>
              <ul data-aos="fade-up" data-aos-delay="700" className='overflow-hidden pt-4 pb-2 fs-5 list-style-disc fw-normal'>
                <li data-aos="fade-up" data-aos-delay="100" className='py-1'>{t('soilFirst.1')}</li>
                <li data-aos="fade-up" data-aos-delay="200" className='py-1'>{t('soilFirst.2')}</li>
                <li data-aos="fade-up" data-aos-delay="300" className='py-1'>{t('soilFirst.3')}</li>
                <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('soilFirst.4')}</li>
                <li data-aos="fade-up" data-aos-delay="500" className='py-1'>{t('soilFirst.5')}</li>
                <li data-aos="fade-up" data-aos-delay="300" className='py-1'>{t('soilFirst.6')}</li>
                <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('soilFirst.7')}</li>
                <li data-aos="fade-up" data-aos-delay="500" className='py-1'>{t('soilFirst.8')}</li>
                <li data-aos="fade-up" data-aos-delay="600" className='py-1'>{t('soilFirst.9')}</li>
                <li data-aos="fade-up" data-aos-delay="700" className='py-1'>{t('soilFirst.10')}</li>
                <li data-aos="fade-up" data-aos-delay="800" className='py-1'>{t('soilFirst.11')}</li>
              </ul>
            </li>
            <li className='overflow-hidden pt-3'>
              <p data-aos="fade-up" data-aos-delay="700">{t('aggregateTesting')} :</p>
              <ul data-aos="fade-up" data-aos-delay="800" className='pt-4 pb-2 fs-5 list-style-disc fw-normal'>
                <li data-aos="fade-up" data-aos-delay="100" className='py-1'>{t('aggregateSecond.1')}</li>
                <li data-aos="fade-up" data-aos-delay="200" className='py-1'>{t('aggregateSecond.2')}</li>
                <li data-aos="fade-up" data-aos-delay="300" className='py-1'>{t('aggregateSecond.3')}</li>
                <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('aggregateSecond.4')}</li>
                <li data-aos="fade-up" data-aos-delay="500" className='py-1'>{t('aggregateSecond.5')}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div data-aos="fade-down" className="col-xxl-4 col-xl-5 col-lg-6">
          <Slider
            dots={true}
            autoplay={true}
            infinite={true}
            speed={1600}
            autoplaySpeed= {1600}
            initialSlide= {0}
            slidesToShow={3}
            slidesToScroll={3}
            rtl={language==='en'? false:true}
            vertical= {true}
            verticalSwiping= {true}
            responsive={[
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  vertical: false,
                  verticalSwiping: false,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  vertical: false,
                  verticalSwiping: false,
                },
              },
            ]}
          >
            {soilTestImages.map((image, index) => <div className='px-lg-0 px-2' key={index}>
              <img loading='lazy' className='w-100 rounded-3' src={image} alt="soil tests" />
            </div>)}
          </Slider>
        </div>
      </div>
    </section>

      <section id='asphaltTest' className='w-100 pt-5 overflow-hidden'>
        <p data-aos="fade-up" data-aos-delay="400" className='fs-4 fw-bold pt-3 mt-md-5 mb-4 position-relative w-fit line3 text-main2'>2. {t('navAsphaltTest')} :</p>
        <p data-aos="fade-up" data-aos-delay="400">{t('asphalt.text1')}</p>
        <p data-aos="fade-up" data-aos-delay="400" className='fw-bold py-3 fs-5 text-justify'>{t('asphalt.text2')}</p>
        <div className="px-lg-4 px-2">
          <p data-aos="fade-up" data-aos-delay="700" className='fs-5 fw-semibold'>{t('asphalt.text3.text')}</p>
          <div className="row pt-4 g-3 px-md-4">
            <div className="col-xl-7 col-lg-6">
              <ul data-aos="fade-up" data-aos-delay="900" className={`list-style-auto fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'}`}>
                <li data-aos="fade-up" data-aos-delay="100" className='py-1'>{t('asphalt.text3.1')}</li>
                <li data-aos="fade-up" data-aos-delay="200" className='py-1'>{t('asphalt.text3.2')}</li>
                <li data-aos="fade-up" data-aos-delay="300" className='py-1'>{t('asphalt.text3.3')}</li>
                <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('asphalt.text3.4')}</li>
                <li data-aos="fade-up" data-aos-delay="500" className='py-1'>{t('asphalt.text3.5')}</li>
                <li data-aos="fade-up" data-aos-delay="600" className='py-1'>{t('asphalt.text3.6')}</li>
                <li data-aos="fade-up" data-aos-delay="700" className='py-1'>{t('asphalt.text3.7')}</li>
                <li data-aos="fade-up" data-aos-delay="800" className='py-1'>{t('asphalt.text3.8')}</li>
              </ul>
            </div>
            <div data-aos="zoom-in" data-aos-delay="900" className="col-xl-5 col-lg-6 d-lg-flex d-none">
              <div className='px-2'>
                <img loading='lazy' className='w-100 rounded-3' src={asphaltTest} alt={t('navAsphaltTest')} />
              </div>
            </div>
          </div>
        </div>
        <div className="pt-lg-5 pt-3">
          <p data-aos="fade-up" data-aos-delay="700" className='fw-bold py-3 fs-5'>{t('asphalt.text4.text')}</p>
          <ul data-aos="fade-up" data-aos-delay="800" className={`list-style-disc fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'}`}>
            <li data-aos="fade-up" data-aos-delay="100" className='py-1 text-justify'>{t('asphalt.text4.1')}</li>
            <li data-aos="fade-up" data-aos-delay="200" className='py-1 text-justify'>{t('asphalt.text4.2')}</li>
            <li data-aos="fade-up" data-aos-delay="300" className='py-1 text-justify'>{t('asphalt.text4.3')}</li>
            <li data-aos="fade-up" data-aos-delay="400" className='py-1 text-justify'>{t('asphalt.text4.4')}</li>
          </ul>
        </div>
        <div className="pt-lg-5 py-3">
          <p data-aos="fade-up" data-aos-delay="900" className='fw-bold py-3 fs-5 text-justify'>{t('asphalt.text5.text')}</p>
          <ul data-aos="fade-up" data-aos-delay="1000" className={`list-style-disc fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'}`}>
            <li data-aos="fade-up" data-aos-delay="100" className='py-1'>{t('asphalt.text5.1')}</li>
            <li data-aos="fade-up" data-aos-delay="200" className='py-1'>{t('asphalt.text5.2')}</li>
          </ul>
        </div>
        <div data-aos="fade-right" data-aos-delay="1000" >
          <Slider
            dots={true}
            autoplay={true}
            infinite={true}
            speed={1600}
            autoplaySpeed= {1600}
            initialSlide= {0}
            slidesToShow={3}
            slidesToScroll={3}
            rtl={language==='en'? false:true}
            responsive={[
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {asphaltTestImages.map((image, index) => <div className='px-2 cursor-grab' key={index}>
              <img loading='lazy' className='w-100 rounded-3' src={image} alt="soil tests" />
            </div>)}
          </Slider>
        </div>
      </section>

      <section id='liquidBitumenTest' className='w-100 pt-5'>
        <p data-aos="fade-up" data-aos-delay="1000" className='fs-4 fw-bold pt-3 mb-4 mt-md-5 position-relative w-fit line3 text-main2'>3. {t('navLiquidBitumenTest')} :</p>
        <p data-aos="fade-up" data-aos-delay="1200" className='fw-bold py-3 fs-5 '>{t('bitumenText')}</p>
        <div className="row pt-4 g-lg-3 gx-1 gy-5 px-md-4">
          <div className="col-xxl-8 col-xl-7 col-lg-6">
            <div>
              <ul data-aos="fade-up" data-aos-delay="1300" className={`list-style-disc fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'} mb-0`}>
                <li data-aos="fade-up" data-aos-delay="100" className='py-1'>{t('penetration')}</li>
                <li data-aos="fade-up" data-aos-delay="200" className='py-1'>{t('viscosity')}</li>
                <li data-aos="fade-up" data-aos-delay="300" className='py-1'>{t('ductility')}</li>
                <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('softeningPoint')}</li>
                <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('flashAndFire')}</li>
                <li data-aos="fade-up" data-aos-delay="500" className='py-1'>{t('specificGravity')}</li>
                <li data-aos="fade-up" data-aos-delay="600" className='py-1'>{t('solubility')}</li>
                <li data-aos="fade-up" data-aos-delay="700" className='pt-1'>{t('volatility')}</li>
              </ul>
            </div>
          </div>
          <div className="col-xxl-4 col-xl-5 col-lg-6 d-lg-flex d-none">
            <div data-aos="zoom-in" data-aos-delay="1200" className='px-2'>
              <img loading='lazy' className='w-100 rounded-3' src={bitumen1} alt="Bitumen Sprayer Truck Asphalt Distributor" />
            </div>
          </div>
          {bitumenImages.map((image,index) => <div key={image.id} data-aos="zoom-in-up" data-aos-delay={`${(index + 10) * 100}`} className="col-md-2 col-sm-4 col-6 pt-md-4">
            <div>
              <img loading='lazy' className='w-100' src={image.image} alt={image.name} />
            </div>
          </div>
          )}
        </div>
      </section>

      <section id='concreteTest' className='w-100 pt-5'>
        <p data-aos="fade-up" data-aos-delay="1000" className='fs-4 fw-bold pt-3 mb-4 mt-lg-5 position-relative w-fit line3 text-main2'>4. {t('navConcreteTest')} :</p>
        <p data-aos="fade-up" data-aos-delay="1200" className='fs-5 py-3 lh-md text-justify'>{t('concrete.text1')}<br />{t('concrete.text2')}</p>
        <p data-aos="fade-up" data-aos-delay="1300" className='fw-bold fs-5 py-3 text-justify'>{t('concrete.text3.text')}</p>
        <div className="row gy-0 g-lg-3 gx-1 pt-3 pb-5 align-items-center">
          <div className="col-xl-7 col-lg-6">
            <ul data-aos="fade-up" data-aos-delay="1400" className={`list-style-auto fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'} mb-0`}>
              <li data-aos="fade-up" data-aos-delay="500">
                <p data-aos="fade-up" data-aos-delay="100" className='pb-3 fw-medium'>{t('concrete.text3.one.name')}</p>
                <ul data-aos="fade-up" data-aos-delay="400" className={`list-style-disc ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'}`}>
                  <li data-aos="fade-up" data-aos-delay="200" className='py-2'>{t('concrete.text3.one.1')}</li>
                  <li data-aos="fade-up" data-aos-delay="400" className='py-2'>{t('concrete.text3.one.2')}</li>
                  <li data-aos="fade-up" data-aos-delay="600" className='py-2'>{t('concrete.text3.one.3')}</li>
                  <li data-aos="fade-up" data-aos-delay="800" className='py-2'>{t('concrete.text3.one.4')}</li>
                  <li data-aos="fade-up" data-aos-delay="1000" className='py-2'>{t('concrete.text3.one.5')}</li>
                </ul>
              </li>
              <li data-aos="fade-up" data-aos-delay="800" className='fw-medium pt-4'>{t('concrete.text3.two')}</li>
            </ul>
          </div>
          <div data-aos="fade-up" data-aos-delay="1000" className="col-xl-5 col-lg-6 d-lg-flex d-none">
            <div className='px-2'>
              <img loading='lazy' className='w-100 rounded-3' src={concentrate} alt={t('navConcreteTest')} />
            </div>
          </div>
        </div>
        <p data-aos="fade-up" data-aos-delay="1100" className='fw-bold fs-5 py-3 '>{t('concrete.text4.text')}</p>
        <ul data-aos="fade-up" data-aos-delay="1200" className={`list-style-auto fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'} mb-0`}>
          <li className='py-3'>
            <p data-aos="fade-up" data-aos-delay="1000" className='pb-3 fw-semibold'>{t('concrete.text4.firstName')}</p>
            <p data-aos="fade-up" data-aos-delay="1200" className='lh-md text-justify'>{t('concrete.text4.firstText')}</p>
          </li>
          <li className='py-3'>
            <p data-aos="fade-up" data-aos-delay="1400" className='pb-3 fw-semibold'>{t('concrete.text4.secondName')}</p>
            <p data-aos="fade-up" data-aos-delay="1600" className="lh-md text-justify">{t('concrete.text4.secondText')}</p>
          </li>
        </ul>
        <div data-aos="fade-right" data-aos-delay="1800">
          <Slider
            dots={true}
            autoplay={true}
            infinite={true}
            speed={1600}
            autoplaySpeed= {1600}
            initialSlide= {0}
            slidesToShow={3}
            slidesToScroll={3}
            rtl={language==='en'? false:true}
            responsive={[
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {concentrateImages.map((image, index) => <div className='px-2 cursor-grab' key={index}>
              <img loading='lazy' className='w-100 rounded-3' src={image} alt="soil tests" />
            </div>)}
          </Slider>
        </div>
      </section>

      <section data-aos="fade-up" data-aos-delay="1000" id='blockTileTest' className='w-100 pt-5 pb-sm-5 pb-3'>
        <p data-aos="fade-up" data-aos-delay="500" className='fs-4 fw-bold pt-3 mb-4 mt-md-5 position-relative w-fit line3 text-main2'>5. {t('navBlockTileTest')} :</p>
        <div className="row align-items-center">
          <div className="col-lg-4">
            <ul data-aos="fade-up" data-aos-delay="700" className={`list-style-disc fs-5 ${language==='en'? 'ps-4 pe-0':'pe-4 ps-0'} mb-0 lh-lg`}>
              <li data-aos="fade-up" data-aos-delay="100" className='py-1'>{t('block.1')}</li>
              <li data-aos="fade-up" data-aos-delay="400" className='py-1'>{t('block.2')}</li>
              <li data-aos="fade-up" data-aos-delay="700" className='py-1'>{t('block.3')}</li>
            </ul>
          </div>
          <div className="col-lg-8 row px-0 pt-4">
            <div className='col-4'>
              <div data-aos="zoom-in" data-aos-delay="1100">
                <img loading='lazy' className='w-100 rounded-3' src={blockTile1} alt={t('navBlockTileTest')} />
              </div>
            </div>
            <div className='col-4'>
              <div data-aos="zoom-in" data-aos-delay="1400">
                <img loading='lazy' className='w-100 rounded-3' src={blockTile3} alt={t('navBlockTileTest')} />
              </div>
            </div>
            <div className='col-4'>
              <div data-aos="zoom-in" data-aos-delay="1700">
                <img loading='lazy' className='w-100 rounded-3' src={blockTile2} alt={t('navBlockTileTest')} />
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>
  </>
}
